import React from "react";

interface Props {
  width?: number;
  height?: number;
  color?: string;
}

const IconCopy = ({ width = 24, height = 24, color = "#515C6C" }: Props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 21 20"
      fill="none"
    >
      <path
        d="M16.0553 7.2915C17.1675 7.2915 18.0689 8.19304 18.069 9.30518V15.5552C18.069 16.6674 17.1675 17.5688 16.0553 17.5688H9.8053C8.69316 17.5687 7.79163 16.6673 7.79163 15.5552V9.30518C7.79174 8.19311 8.69323 7.29163 9.8053 7.2915H16.0553ZM9.8053 8.5415C9.38359 8.54163 9.04174 8.88347 9.04163 9.30518V15.5552C9.04163 15.977 9.38352 16.3187 9.8053 16.3188H16.0553C16.4772 16.3188 16.819 15.9771 16.819 15.5552V9.30518C16.8189 8.88339 16.4771 8.5415 16.0553 8.5415H9.8053ZM11.3932 2.43994C11.854 2.48569 12.2874 2.68979 12.6178 3.02002C12.9954 3.39759 13.2075 3.90989 13.2076 4.44385V5.13818C13.2076 5.48336 12.9278 5.76318 12.5826 5.76318C12.2378 5.76283 11.9576 5.48314 11.9576 5.13818V4.44385C11.9575 4.24141 11.8772 4.04696 11.734 3.90381C11.6267 3.7967 11.4908 3.72419 11.3444 3.69482L11.194 3.68018H4.94397C4.74153 3.68029 4.54708 3.76065 4.40393 3.90381C4.26078 4.04696 4.18041 4.24141 4.1803 4.44385V10.6938L4.19495 10.8442C4.22431 10.9907 4.29683 11.1266 4.40393 11.2339C4.54709 11.377 4.74153 11.4574 4.94397 11.4575H5.63831L5.76428 11.4702C6.04907 11.5283 6.263 11.7806 6.26331 12.0825C6.26331 12.3846 6.04919 12.6366 5.76428 12.6948L5.63831 12.7075H4.94397C4.41001 12.7074 3.89772 12.4953 3.52014 12.1177C3.18992 11.7872 2.98581 11.3539 2.94006 10.8931L2.9303 10.6938V4.44385C2.93041 3.90989 3.14257 3.39759 3.52014 3.02002C3.89772 2.64244 4.41001 2.43029 4.94397 2.43018H11.194L11.3932 2.43994Z"
        fill={color}
      />
    </svg>
  );
};

IconCopy.displayName = "Copy";

export default IconCopy;
